<template>
    <div class="home-statics">
        <div>
                <h1>网站访问量统计</h1>
        </div>
        <div class="static-home" style="display: flex;margin-top: 20px;justify-content: space-evenly;">
        
            
            <div class="home-left" style="">
                <el-form :inline="true"  class="demo-form-inline" style="display: inline; width: 200px;">
                    <el-form-item label="统计区间">
                        <el-cascader
                            ref="cascaderRef"
                            class="cascader"
                            v-model="selected_total_statistic_field"
                            :options="total_statistic_field_options"
                            @change="total_statistic_field_changed"
                            
                            >
                        </el-cascader>
                    </el-form-item>
                </el-form>
                <el-table
                :data="statistics"
                >
                    <el-table-column
                        prop="field"
                        label="时间"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="see_num"
                        label="访问量"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="view_num"
                        label="商品浏览量"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="collect_num"
                        label="商品收藏量"
                        width="180">
                    </el-table-column>
                </el-table>
                
                 <!-- 分页 -->
                <el-pagination
                @size-change="statictis_handleSizeChange"
                @current-change="statictis_handleCurrentChange"
                :current-page="total_statictis_page"
                :page-sizes="[8, 16,20]"
                :page-size="total_statictis_page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total_staticstics_count"
                class="pagination"
                ></el-pagination>
            </div>
            

            <div class="home-right">
                <div>

                    <el-form :inline="true"  class="demo-form-inline" style="display: inline; width: 200px;">
                        <el-form-item label="类型">
                            <el-cascader
                                ref="cascaderRef"
                                class="cascader"
                                v-model="selected_products_rank_type_field"
                                :options="products_rank_type_field_options"
                                :placeholder="defalut_selected_products_rank_type_placeholder"
                                @change="select_product_type_change"
                                
                                >
                            </el-cascader>
                        </el-form-item>

                        <el-form-item>
                            <el-date-picker
                                v-model="pickedtime"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="timepickerOptions"
                                @change="product_time_change">
                                </el-date-picker>
                        </el-form-item>
                    </el-form>
                    
                </div>
                <el-table :data="products_rank_list" tooltip-effect="dark">
                   
                    <!-- 当内容过长被隐藏时显示 tooltip -->
                    <el-table-column width="200px" label="商品" align="center" prop="info_lang" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="cover-name" style="display: flex;align-items: center;" v-if="scope.row.good_info">
                                <img class="good-img" :src="`${baseURL}/${scope.row.good_info.cover}?q=30`" style="object-fit: cover; width: 100px;height: 100px;"/>
                                <div>
                                <div class="good-name">{{ scope.row.good_info.name_lang }}</div>
                                <span class="good-id" style="display: block;">id:{{scope.row.good_info.id}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="good_info.category_str" align="center" label="分类"></el-table-column>
                    <el-table-column prop="num" align="center" label="数量"></el-table-column>
                   
                   
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                    @size-change="product_hanldle_size_change"
                    @current-change="productCurrentChange"
                    :current-page="products_rank_page"
                    :page-sizes="[10, 16, 20]"
                    :page-size="products_rank_page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="products_rank_total_count"
                    class="pagination"
                    ></el-pagination>

            </div>
        </div>
    
    </div>
   
  </template>
  
  <script>
  import { goods_statistics, statistics } from '../api/api';
  import { baseURL } from '../api/api';
  export default {
    data() {
      return {
        baseURL,
        total_statictis_page:1,
        total_statictis_page_size:20,
        total_staticstics_count:0,
        statistics: [],
        total_staticstics_filed:'day',
        selected_total_statistic_field:['day'],
        total_statistic_field_options:[{
            label:'day',
            value:'day'
        },
        {
            label:'month',
            value:'month'
        },
        {
            label:'year',
            value:'year' 
        }],


        products_rank_page:1,
        products_rank_page_size:10,
        products_rank_total_count:0,
        products_rank_list: [],
        products_rank_type:2,//1收藏，2查看
        selected_products_rank_type_field:[2],
        defalut_selected_products_rank_type_placeholder:'查看',
        products_rank_type_field_options:[{
            label:'查看',
            value:'2'
        },
        {
            label:'收藏',
            value:'1'
        }],

        timepickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        pickedtime: [],
        product_start_timestamp:0,
        product_end_timestamp:0
      };
    },
    mounted(){
        this.update_total_statistics(this.total_staticstics_filed,this.total_statictis_page,this.total_statictis_page_size)
        this.update_goods_statistics()
   
    },
    methods:{
        update_total_statistics(field,page,limit){
            statistics(field,page,limit)
            .then(res=>{
                this.total_staticstics_count = res.total
                this.statistics = res.list
            })
        },

        update_goods_statistics(){
            goods_statistics({ctype:Number(this.products_rank_type),btime:this.product_start_timestamp/1000,etime:this.product_end_timestamp/1000, page:this.products_rank_page,limit:this.products_rank_page_size}).then(res=>{
                console.log('goods_statistics:',res)
                this.products_rank_list = res.list
                this.products_rank_total_count = res.total
            })
        },

        statictis_handleSizeChange(size){
           this.total_statictis_page_size = size;
           this.update_total_statistics(this.total_staticstics_filed,this.total_statictis_page,this.total_statictis_page_size)

        },
        statictis_handleCurrentChange(page){
            this.total_statictis_page = page
            this.update_total_statistics(this.total_staticstics_filed,this.total_statictis_page,this.total_statictis_page_size)
        },
        total_statistic_field_changed(val){
           
            this.total_staticstics_filed = this.selected_total_statistic_field[0]
            this.update_total_statistics(this.total_staticstics_filed,this.total_statictis_page,this.total_statictis_page_size)
           
        },
        select_product_type_change(){
            //ctype
            this.products_rank_type = this.selected_products_rank_type_field[0]
            this.update_goods_statistics()
        },
        product_time_change(){
            this.product_start_timestamps = this.pickedtime[0].getTime()
            this.product_end_timestamps = this.pickedtime[1].getTime()
            this.update_goods_statistics()
        },
        product_hanldle_size_change(size){
            this.products_rank_page_size = size
            this.update_goods_statistics()
        },
        productCurrentChange(page){
            this.products_rank_page = page;
            this.update_goods_statistics()
        }
    },
  }

  </script>
  
  <style scoped>

  .like {
    cursor: pointer;
    font-size: 25px;
    display: inline-block;
  }
  .product-stats-container {
    padding: 20px;
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .stats-overview {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .charts-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 30px;
  }
  
  .chart-container {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .product-ranking {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .product-ranking h3 {
    margin: 20px 0;
  }
  .cascader{
    width: 200px;
  }
  </style>